const baseFitmentFields = ['Year', 'Make', 'Model', 'Engine'];
const extraFitmentFields = ['Submodel'];
const ignoreFields = ['categories'];

const categorySelectionPageUrl = '/product-category/';
const categoryBrandSelectionPageUrl = '/product-category/brands/';
const brandSelectionPageUrl = '/brands/';

const isShopPage = window.location.pathname === '/shop/';
const isSalesPage = window.location.pathname === '/sales/';
const isDealsPage = window.location.pathname === '/deals/';

const isCategorySelectionPage = window.location.pathname === categorySelectionPageUrl;
const isCategoryBrandSelectionPage = window.location.pathname === categoryBrandSelectionPageUrl;

const isCategoryPage =
  window.location.pathname.includes(categorySelectionPageUrl) &&
  !isCategorySelectionPage &&
  !isCategoryBrandSelectionPage;

function ajaxAddToCart(options) {
  const xhr = new XMLHttpRequest();

  xhr.open(options.type, options.url);
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

  xhr.onload = function () {
    if (xhr.status === 200) {
      options.success(JSON.parse(xhr.responseText));
    } else if (options.error) {
      options.error(xhr);
    }
  };
  xhr.onerror = options.error;

  xhr.send(
    Object.keys(options.data)
      .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(options.data[key])}`)
      .join('&'),
  );
}

window.Convermax.addToCart = (e) => {
  e.preventDefault();

  const button = e.target;
  if (!button.getAttribute('data-product_id')) {
    return true;
  }
  button.classList.remove('added');
  button.classList.add('loading');

  const data = {};
  for (const attr of button.attributes) {
    if (attr.name.startsWith('data-')) {
      data[attr.name.slice(5)] = attr.value;
    }
  }
  const event = new CustomEvent('adding_to_cart', { detail: { button, data } });
  document.body.dispatchEvent(event);

  ajaxAddToCart({
    type: 'POST',
    url: '/?wc-ajax=add_to_cart',
    data,
    success: (response) => {
      if (!response) {
        return;
      }

      if (response.error && response.product_url) {
        window.location = response.product_url;
        return;
      }

      const addedEvent = new CustomEvent('added_to_cart', {
        // eslint-disable-next-line camelcase
        detail: { fragments: response.fragments, cart_hash: response.cart_hash, button },
      });
      document.body.dispatchEvent(addedEvent);
      button.classList.remove('loading');
    },
    dataType: 'json',
  });
};

const InitFunc = () => {
  function updateFragments(e) {
    const { fragments } = e.detail;
    if (fragments) {
      Object.keys(fragments).forEach((selector) => {
        const element = document.querySelector(selector);
        if (element) {
          element.outerHTML = fragments[selector];
        }
      });
      const event = new CustomEvent('wc_fragments_loaded');
      document.body.dispatchEvent(event);
    }
  }
  if (document.getElementById('cm_results')) {
    document.body.addEventListener('added_to_cart', updateFragments);
  }
};

function getLocalPreselection() {
  if (isSalesPage) {
    return [{ field: 'on_garage_sale', term: 'True' }];
  }
  if (isDealsPage) {
    return [{ field: 'on_sale', term: 'True' }];
  }

  if ((isCategoryPage || isCategoryBrandSelectionPage) && window.cm_category) {
    return [
      {
        field: 'categories',
        term: window.cm_category,
        treeLevel: window.cm_category.length - 1,
      },
    ];
  }

  if (window.location.pathname.startsWith('/brand/') && window.location.pathname !== brandSelectionPageUrl) {
    const term = document.querySelector('.kadence-bread-current').textContent;

    return [
      {
        field: 'brand',
        term,
      },
    ];
  }

  return null;
}

const AfterInit = () => {
  const fitmentTable = document.querySelector('#tab-fitment');

  if (fitmentTable) {
    fitmentTable.style.display = 'none'; // hide fitment table on page load
  }
};

export default {
  platform: 'woocommerce',
  searchPageUrl: '/ymm-search/',
  getLocalPreselection,
  AfterInit,
  InitFunc,
  sortFields: ['relevance', 'total_sales:desc', 'name', 'name:desc', 'price', 'price:desc'],
  SearchRequestDefaults: {
    pageSize: 36,
    extra: window.cm_customer_roles
      ? {
          customerRoles: window.cm_customer_roles?.join(','),
        }
      : {},
  },
  product: {
    noImageSrc: '/wp-content/uploads/woocommerce-placeholder-300x300.png',
  },
  fitmentSearch: {
    baseFields: baseFitmentFields,
    extraFields: extraFitmentFields,
    categorySelectionPages: [
      { pathname: categorySelectionPageUrl, field: 'filtered_categories' },
      { pathname: categoryBrandSelectionPageUrl, field: 'categories' },
      { pathname: brandSelectionPageUrl, field: 'brand' },
    ],
    categorySelectionPageRedirect: true,
  },
  Widgets: [
    {
      name: 'SearchPage',
      location: '#cm_results',
      template: 'SearchPage',
    },
    {
      name: 'ShopPage',
      type: 'SearchPage',
      location: { replace: '.products' },
      template: 'SearchPage',
      visibleIf: () => isShopPage || isSalesPage || isDealsPage,
    },
    {
      name: 'CategoryPage',
      type: 'SearchPage',
      location: {
        replace: 'body.tax-product_cat .products, body.tax-product_cat .woocommerce-no-products-found',
      },
      template: 'SearchPage',
      visibleIf: () =>
        !window.Convermax.showConvermaxResults !== false &&
        !isCategorySelectionPage &&
        !isCategoryBrandSelectionPage,
    },
    {
      name: 'BrandPage',
      type: 'SearchPage',
      location: {
        replace: 'body.tax-pa_brand .products, body.tax-pa_brand .woocommerce-no-products-found',
      },
      template: 'SearchPage',
      visibleIf: () => !window.Convermax.showConvermaxResults !== false && !isCategoryBrandSelectionPage,
    },
    {
      name: 'SearchHeader',
      sortSelectClass: 'form-select form-select--small',
    },
    {
      name: 'SearchResult',
    },
    {
      name: 'SearchBox',
      location: '.cm-searchbox__container',
      template: 'SearchBox',
    },
    {
      name: 'SearchBoxDialogButtonMobile',
      type: 'SearchBoxDialogButton',
      location: '.cm-search-box-mobile__container',
      template: 'searchBox/dialogButtonAdaptable',
    },
    {
      name: 'FilterSearchBox',
    },
    {
      name: 'FilterChips',
      type: 'FacetPanel',
      ignoreFields,
    },
    {
      name: 'Facets',
      type: 'FacetPanel',
      ignoreFields,
    },
    {
      name: 'HeaderVehicleWidget',
      type: 'VehicleWidget',
      location: {
        lastChildOf: 'body.home #masthead',
        class: 'cm_vehicle-widget__home-container',
      },
      template: 'fitmentSearch/collapsibleVehicleWidget',
      columnBreakpoint: 760,
      isAlwaysActive: true,
      initCollapsed: true,
    },
    {
      name: 'SearchVehicleWidget',
      type: 'VehicleWidget',
      isAlwaysActive: true,
    },
    {
      name: 'RelatedItems',
      location: 'body.product-template-default .related.products',
      template: 'product/relatedItems',
      count: 4,
      useManualItems: true,
    },
    {
      name: 'Garage',
      location: {
        insertBefore: '#main-header .site-header-item[data-section="kadence_customizer_header_account"]',
        class: 'cm_garage__container',
      },
      template: 'fitmentSearch/garage',
    },
    {
      name: 'VerifyFitment',
      location: {
        insertAfter: 'body.product-template-default .product .cart',
      },
      template: 'fitmentSearch/verifyFitment',
    },
    {
      name: 'FitmentTableTab',
      type: 'FitmentTable',
      location: {
        insertAfter: 'body.product-template-default .woocommerce-tabs .description_tab',
        wrapper: 'li',
        id: 'tab-title-fitment',
        class: 'fitment_tab',
      },
      template: 'fitmentSearch/fitmentTableTab',
    },
    {
      name: 'FitmentTable',
      location: {
        id: 'tab-fitment',
        class: 'woocommerce-Tabs-panel woocommerce-Tabs-panel--fitment panel entry-content wc-tab',
        insertAfter: 'body.product-template-default .woocommerce-Tabs-panel--description',
      },
      template: 'fitmentSearch/fitmentTable',
    },
    // used on https://5startuning.com/product-category/brands/
    {
      name: 'CategoryFacetBrandTiles',
      type: 'FacetTiles',
      location: {
        replace: 'body.tax-product_cat.term-brands #main ul.products',
      },
      template: 'facetTiles/hierarchicalContainer',
      visibleIf: () => window.Convermax.showConvermaxResults !== false && isCategoryBrandSelectionPage,
    },
    {
      name: 'FacetBrandTiles',
      type: 'FacetTiles',
      location: '#cm-brand-list',
      template: 'facetTiles/alphabeticalContainer',
      view: 'grid',
    },
    {
      name: 'FacetCategoryTiles',
      type: 'FacetTiles',
      location: '#cm_categories',
      template: 'facetTiles/hierarchicalContainer',
      visibleIf: () => isCategorySelectionPage,
      isMultiLevel: true,
    },
    {
      name: 'FacetDialog',
      template: 'FacetDialogVehicleSpecs',
      ignoreFields,
    },
    {
      name: 'SearchBoxDialog',
      template: 'SearchBoxDialog',
    },
    {
      name: 'VehicleWidgetDialog',
      template: 'fitmentSearch/dialog',
    },
  ],
};
